import React  from 'react'
import { ConfigProvider } from 'antd'
import { Locale } from 'antd/lib/locale-provider'
import _default from 'antd/lib/locale-provider/ko_KR'

interface Props {
  children?: React.ReactNode
}

export default function IntlWrapper({ children }: Props) {
  const antdLocaleData = _default as Locale
  return (
    <ConfigProvider locale={antdLocaleData}>
      {children}
    </ConfigProvider>
  )
}
